var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login-reg" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "log-box main" }, [
          _c(
            "form",
            {
              staticClass: "gen-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doRegister($event)
                }
              }
            },
            [
              _c("div", { staticClass: "form-row split" }, [
                _c("div", [
                  _c("label", [_vm._v("First name:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.register.firstname,
                        expression: "register.firstname"
                      }
                    ],
                    attrs: { type: "text", required: "" },
                    domProps: { value: _vm.register.firstname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.register, "firstname", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [_vm._v("Last name:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.register.lastname,
                        expression: "register.lastname"
                      }
                    ],
                    attrs: { type: "text", required: "" },
                    domProps: { value: _vm.register.lastname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.register, "lastname", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("label", [_vm._v("Email:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.register.username,
                      expression: "register.username"
                    }
                  ],
                  attrs: { type: "email", required: "" },
                  domProps: { value: _vm.register.username },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.register, "username", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("label", [_vm._v("Password:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.register.password,
                      expression: "register.password"
                    }
                  ],
                  attrs: { type: "password", required: "" },
                  domProps: { value: _vm.register.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.register, "password", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("label", [_vm._v("Confirm password:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.register.password2,
                      expression: "register.password2"
                    }
                  ],
                  attrs: { type: "password", required: "" },
                  domProps: { value: _vm.register.password2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.register, "password2", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row split" }, [
                _c("label", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.register.agreed,
                        expression: "register.agreed"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.register.agreed)
                        ? _vm._i(_vm.register.agreed, null) > -1
                        : _vm.register.agreed
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.register.agreed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.register,
                                "agreed",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.register,
                                "agreed",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.register, "agreed", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("em"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("I agree to "),
                    _c(
                      "a",
                      {
                        attrs: { href: "", target: "_blank" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showTc($event)
                          }
                        }
                      },
                      [_vm._v("terms and conditions")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "log-box sec existing-account" }, [
          _c("div", { staticClass: "exi-title" }, [
            _vm._v("Great to see you back online for more learning")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "exi-subtitle" }, [
            _vm._v("Have you already created your account?")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-act" },
            [
              _c(
                "router-link",
                { staticClass: "lbtn", attrs: { to: { name: "user.login" } } },
                [_vm._v("Login")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "subpage-head" }, [
      _c("div", { staticClass: "container" }, [_c("h1", [_vm._v("Register")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-act" }, [
      _c("button", { staticClass: "lbtn" }, [_vm._v("Register")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }